// @ts-strict-ignore
/**
 * This function converts our own and Quill markup (used in InputEditorComponent) into somewhat cleaner html.
 * @param string The string to convert
 * @returns Stringified html
 */

export function toHtml(string: string) {
  if (!string) {
    return string;
  }

  const regexParagraph = /<p>.*<\/p>/g;
  const regexQuill1NewLine = /<p><br><\/p>/g; // How a new line is generated by Quill v1.x
  const regexQuill2NewLine = /<p><\/p>/g; // How a new line is generated by Quill v2.x
  const isAlreadyHtml = regexParagraph.test(string);
  if (isAlreadyHtml) {
    const s = string.replace(regexQuill1NewLine, '<br>').replace(regexQuill2NewLine, '<br>');
    return s === '<br>' ? '' : s;
  }

  const regexMarkupLink = /\[(.+?)\]\((.+?)\)/g;
  const replacementMarkupLink = '<a href="$2" target="_blank">$1</a>';
  string = string.replace(regexMarkupLink, replacementMarkupLink);

  // const regexMarkupUrl = /(?<!"|">[A-Za-zÀ-ÖØ-öø-ÿ\s:-]*?)(https?:\/\/\S+)/g;
  // A simple replace with above would be preferable to expand urls that are not already the text content or href of an <a> tag.
  // Lookbehinds are not supported in safari though so instead below is a workaround doing the same thing.
  const regexMarkupUrl = /("|">[A-Za-zÀ-ÖØ-öø-ÿ\s:-]*?)?(https?:\/\/\S+)/g;
  const markupUrlMatches = Array.from(string.matchAll(regexMarkupUrl));
  if (markupUrlMatches.length) {
    let indexDelta = 0;
    markupUrlMatches.forEach((m) => {
      if (m[1] === undefined) {
        const startOfString = string.slice(0, m['index'] + indexDelta);
        const replacementMarkupUrl = `<a href="${m[0]}" target="_blank">${m[0]}</a>`;
        const endOfString = string.slice(m['index'] + m[0].length + indexDelta);
        string = startOfString + replacementMarkupUrl + endOfString;
        indexDelta += replacementMarkupUrl.length - m[0].length;
      }
    });
  }

  const regexLinebreak = /\n/g;
  string = string.replace(regexLinebreak, '<br>');

  return '<p>' + string + '</p>';
}
